import useGetApi from 'src/api/useGetApi';

interface EligibleSupplierDTO {
  id: string;
  name: string;
  code?: string;
  companyId?: string;
}

export default function useEligibleRebateSuppliers(
  enabled = true,
  scope?: { year?: number; uploadId?: string },
) {
  return useGetApi<EligibleSupplierDTO[]>({
    endpoint: 'rebates/suppliers/eligible',
    queryParameters: {
      ...(scope?.year !== undefined ? { year: scope.year } : {}),
      ...(scope?.uploadId !== undefined ? { uploadId: scope.uploadId } : {}),
    },
    options: { enabled },
  });
}
